import Vue from 'vue'
import Vuex from 'vuex'
import global from './global'
import dashboard from './dashboard/dashboard'
import match from './match/match'
import project from './project/project'
import asset from './asset/asset'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        global,
        dashboard,
        match,
        project,
        asset
    }
})



// WEBPACK FOOTER //
// ./src/store/store.js